import IconInsurance from './IconInsurance'
import IconEnergy from './IconEnergy'
import IconTelecom from './IconTelecom'
import { OptionIconWrapper } from './styled-components'
import useCreateContractModalStyles from './useCreateContractModalStyles'

// eslint-disable-next-line react/prop-types
const OptionIconComponent = ({ iconName, alt }) => {
  const { isPulse, optionIconSize } = useCreateContractModalStyles()
  const icons = {
    energy: () => <IconEnergy size={optionIconSize} color='currentColor' />,
    telecom: () => <IconTelecom size={optionIconSize} color='currentColor' />,
    insurance: () => <IconInsurance size={optionIconSize} color='currentColor' />,
  }
  const IconComponent = icons[iconName] ? icons[iconName] : null

  if (!IconComponent) {
    return null
  }

  return (
    <OptionIconWrapper className='option-icon' title={alt} $pulse={isPulse}>
      <IconComponent />
    </OptionIconWrapper>
  )
}

export default OptionIconComponent
